import { FC, useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";

import { Button } from "@/components/button";
import { Table } from "@/components/table/table";
import { UuidFieldRow } from "@/components/table/uuid-field-row";
import { TextFieldRow } from "@/components/table/text-field-row";
import { CollectionSummarySchema } from "@/domains/openapi/types";

interface CollectionsTableProps {
  data: CollectionSummarySchema[];
  pageSize: number;
  onViewCollection: (id: string) => void;
  onLoadMore?: () => void;
  showLoadMore?: boolean;
  loadMoreLabel?: string;
  isLoadMoreDisabled?: boolean;
}

export const CollectionsTable: FC<CollectionsTableProps> = ({
  data,
  pageSize,
  onViewCollection,
  onLoadMore,
  showLoadMore,
  loadMoreLabel,
  isLoadMoreDisabled,
}) => {
  const columns = useMemo<ColumnDef<CollectionSummarySchema>[]>(
    () => [
      {
        header: "Collection ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.id} />,
      },
      {
        header: "Title",
        cell: ({ row }) => <TextFieldRow value={row.original.title} />,
      },
      {
        header: "Description",
        cell: ({ row }) => <TextFieldRow value={row.original.description} />,
      },
      {
        header: "Owner Space Account",
        cell: ({ row }) => <UuidFieldRow id={row.original.owned_by_space_account_id} />,
      },
      {
        header: "Actions",
        cell: ({ row }) => (
          <Button size="1" onClick={() => onViewCollection(row.original.id)}>
            View
          </Button>
        ),
      },
    ],
    [onViewCollection]
  );

  return (
    <Table
      data={data}
      columns={columns}
      pageSize={pageSize}
      onLoadMore={onLoadMore}
      showLoadMore={showLoadMore}
      loadMoreLabel={loadMoreLabel}
      isLoadMoreDisabled={isLoadMoreDisabled}
    />
  );
};
